import React, { useState } from "react";
import {
  Container,
  Form,
  Button,
  Card,
  Alert,
  Spinner,
  InputGroup,
} from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "../Css/Login.css";
import CryptoJS from "crypto-js";
import { Formik, Field, Form as FormikForm, ErrorMessage } from "formik";
import * as Yup from "yup";
import { FaEye, FaEyeSlash } from "react-icons/fa";

export const hashPassword = (password) => {
  const sha256Hash = CryptoJS.SHA256(password).toString(CryptoJS.enc.Hex);
  const bigIntHash = window.BigInt("0x" + sha256Hash);
  return bigIntHash.toString(32);
};

const validationSchema = Yup.object({
  email: Yup.string()
    .email("Invalid email format")
    .required("Email is required"),
  password: Yup.string()
    .min(6, "Password must be at least 6 characters")
    .required("Password is required"),
});

const Login = () => {
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const togglePasswordVisibility = () => {
    setShowPassword((prevState) => !prevState);
  };

  const handleSubmit = async (values, { setSubmitting, setFieldValue }) => {
    setError("");
    setLoading(true);

    const hashedPassword = hashPassword(values.password);

    console.log("Original Password:", values.password);
    console.log("Hashed Password:", hashedPassword);

    // ✅ Update Formik's field dynamically (this updates the UI)
    setFieldValue("password", "has-password", "id");

    try {
      const response = await fetch(
        "https://api.gkaglobal.org/restgka/login.php",
        {
          method: "POST",

          body: JSON.stringify({
            email: values.email,
            password: hashedPassword, // ✅ Sending hashed password in request
          }),
        }
      );

      const data = await response.json();
      console.log("Response Data:", data);
      setLoading(false);
      setSubmitting(false);

      if (data.status === "success") {
        alert("Login Successful!");
        localStorage.setItem("user", JSON.stringify(data.user));
        window.location.href = "";
      } else {
        setError(data.message || "Invalid credentials. Please try again.");
      }
    } catch (error) {
      setLoading(false);
      setSubmitting(false);
      setError("Network error. Please try again later.");
    }
  };

  return (
    <Container className="container6">
      <Card className="card1 ">
        <Card.Body>
          <h2 className="text-center mb-4 text-primary">Login</h2>
          {error && <Alert variant="danger">{error}</Alert>}

          <Formik
            initialValues={{ email: "", password: "" }}
            validationSchema={validationSchema}
            onSubmit={handleSubmit}
          >
            {({ isSubmitting }) => (
              <FormikForm>
                {/* Email Field */}
                <Form.Group className="form-group">
                  <Field
                    type="email"
                    name="email"
                    className="form-control"
                    placeholder="Enter your email"
                  />
                  <ErrorMessage
                    name="email"
                    component="div"
                    className="text-danger small mt-1"
                  />
                </Form.Group>

                {/* Password Field with Eye Icon Inside */}
                <Form.Group className="form-group">
                  <InputGroup>
                    <Field
                      type={showPassword ? "text" : "password"}
                      name="password"
                      className="form-control"
                      placeholder="Enter your password"
                    />
                    <InputGroup.Text
                      onClick={togglePasswordVisibility}
                      style={{ cursor: "pointer" }}
                    >
                      {showPassword ? <FaEyeSlash /> : <FaEye />}
                    </InputGroup.Text>
                  </InputGroup>
                  <ErrorMessage
                    name="password"
                    component="div"
                    className="text-danger small mt-1"
                  />
                </Form.Group>

                {/* Submit Button */}
                <Button
                  variant="primary"
                  type="submit"
                  className="w-100 mt-3"
                  disabled={isSubmitting || loading}
                >
                  {loading ? <Spinner animation="border" size="sm" /> : "login"}
                </Button>
              </FormikForm>
            )}
          </Formik>
        </Card.Body>
      </Card>
    </Container>
  );
};

export default Login;
